import * as React from "react";
function SvgIcNumerical(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 15H4.713v-4.796H3v-.886C4.015 9.296 4.713 8.735 4.865 8H6v7zm4.3-4.624c0-.708.395-1.267 1.205-1.267.779 0 1.162.506 1.162 1.066 0 .496-.266.908-.884 1.288l-1.141.707C9.437 12.91 9.022 13.828 9 15h5v-1.12h-3.422c.096-.337.373-.58.704-.78l1.343-.824c.831-.507 1.332-1.235 1.332-2.122 0-1.172-.906-2.154-2.43-2.154-1.568 0-2.463 1.066-2.463 2.249 0 .137.021.295.032.39l1.237.085c-.011-.116-.032-.243-.032-.348zm8.292 1.245c.561 0 1.173.338 1.173 1.13 0 .623-.449 1.162-1.255 1.162-.735 0-1.286-.539-1.316-1.33L16 12.835c.082 1.14.99 2.164 2.52 2.164 1.572 0 2.48-1.066 2.48-2.238 0-1.32-.99-2.06-1.98-2.08l1.796-1.626V8h-4.591v1.109h3.01l-1.827 1.689.561.94c.102-.053.306-.117.623-.117z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcNumerical;
